export default {
  data() {
    return {
      restrictors: {
        required: {
          label: 'Обязательное поле',
        },
        email: {
          label: 'E-mail',
        },
        link: {
          label: 'Ссылка',
        },
        number: {
          label: 'Число',
        },
        decimalNumber: {
          label: 'Десятичное число с N знаков после точки',
          input: true,
          default: 1,
        },
        entity: {
          label: 'ID сущности',
        },
        entities: {
          label: 'ID сущностей (несколько)',
        },
        boolean: {
          label: 'Логическое значение',
        },
        contains: {
          label: 'Входит в множество',
          input: true,
        },
        greater: {
          label: 'Больше, чем',
          input: true,
        },
        less: {
          label: 'Меньше, чем',
          input: true,
        },
        lengthGreater: {
          label: 'Длина строки больше, чем',
          input: true,
        },
        lengthLess: {
          label: 'Длина строки меньше, чем',
          input: true,
        },
        unique: {
          label: 'Уникальный параметр',
          input: true,
          default: 'param',
          sync: true,
        },
        filetype: {
          label: 'Тип файла',
          input: true,
        },
      },
      decorators: {
        '': {
          label: 'Не выбран',
        },
        datepicker: {
          label: 'Выбор даты и времени',
        },
        boolean: {
          label: 'Выбор логического значения',
        },
        checkbox: {
          label: 'Множественный выбор',
        },
        radio: {
          label: 'Единичный выбор',
        },
        textarea: {
          label: 'Текстовое поле',
        },
        wysiwyg: {
          label: 'WYSIWYG-редактор',
        },
        entity: {
          label: 'Поиск сущности',
        },
        entities: {
          label: 'Поиск сущностей',
        },
        image: {
          label: 'Загрузка изображения',
        },
        file: {
          label: 'Загрузка файла',
        },
      },
      modifiers: {
        '': {
          label: 'Не выбран',
          handler: '',
        },
        date: {
          label: 'Дата и время',
          handler: '(function (val) {var date = new Date(val * 1000); return val ? date.toLocaleDateString(\'ru-RU\') + \' \' + date.toLocaleTimeString(\'ru-RU\') : ""})',
        },
        boolean: {
          label: 'Логическое значение',
          handler: '(function (val) {return val == 1 ? \'Да\' : val == 0 ? \'Нет\' : ""})',
        },
        link: {
          label: 'Ссылка',
          handler: '(function (val) {return val ? \'<a href="\' + val + \'">\' + val + \'</a>\' : ""})',
        },
        image: {
          label: 'Изображение',
          handler: '(function (val) {return val ? \'<img class="table-img" src="\' + val + \'" />\' : ""})',
        },
        entity: {
          label: 'Ссылка на сущность',
          handler: `(function (val, param, gui, row)
            {
              var vals = Array.isArray(val) ? val : val.split(',');

              vals = vals.map((val, index) => {
                var match = param.match(/^(\\w*)_ids?$/);
                var entity = match && match[1];
                var id = entity && val;
                if (!id) {
                  match = param.match(/^(\\w*)\\.(\\w*)$/);
                  entity = match && match[1];
                  var idsList = row[entity + '_ids'];
                  
                  id = entity && (idsList ? idsList[index] : row[entity + '_id']);
                }

                if (!id || !entity) {
                  return val;
                }

                var filter = '?filter=%255B%257B%22column%22%253A%22id%22%2C%22operator%22%253A%22%253D%22%2C%22value%22%253A%22' + id + '%22%2C%22children%22%253A%255B%255D%2C%22condition%22%253A%22OR%22%2C%22childCondition%22%253A%22OR%22%257D%255D';
                var href = 'https://api.vsenauka.ru/entity/' + entity + filter;
                return val ? '<a href="' + href + '">' + val + '</a>' : ''
              });
              
              return vals.join(', ');
            })`,
        },
        ellipsis: {
          label: 'Длинный текст',
          handler: '(function (val, param, gui) {return val.length > 25 ? val.replace(/(<([^>]+)>)/ig,"").substring(0,25) + "<a data-val=\'" + encodeURIComponent(val.replace(/\'/g, "%27")) + "\' data-gui=\'" + gui + "\' class=\'_show-ellipsis-value\' href=\'#\'>...</a>" : val })',
        },
      },
    };
  },
};
